import { jwtDecode } from "jwt-decode";
import { loginSuccess } from "../../../store/slices/authSlice";

export default function responseSignIn(response: any, api: any, arg: any) {
    debugger
     if (response && response?.data?.token) {
        api.dispatch(loginSuccess({ token: response.data.token, user: response.data.user }));
    }
    return response;
}